import { render } from "./HeroiconsOutlineThumbDown.vue?vue&type=template&id=4ecbb21e"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineThumbDown.vue"]])

export default __exports__